import React, { useEffect, useState } from 'react'
import './ViewConsultant.css';
import { Link, useParams } from 'react-router-dom';
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import SearchBar from '../Main/searchBar';
import ConsultantDetailsCard from './ConsultantDetailsCard';
import ViewConsultantTable from './ViewConsultantTable';
import { useDispatch, useSelector } from 'react-redux';
import { viewConsultantProfile } from '../../Redux/Actions/consultantAction';
import { Modal } from 'antd';
import ConsultantConstant from './ConstultantConstant';


const ViewConsultant = () => {
  const [documentModalOpen, setDocumentModalOpen] = useState(false)
  const handleToggleModal = () => {
    setDocumentModalOpen(prev => !prev);
  };
  const { id } = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    if (id) {
      dispatch(viewConsultantProfile(id));
    }
  }, [dispatch, id]);
  const { data, loading, error } = useSelector((state) => state.consultantView);

  return (
    <div className="viewConsultant-container">
      <div className="searchbar-wrapper">
        <div className="searchbar-container">
          <SearchBar />
        </div>
      </div>
      <div className="consultant-row-one">
        <div className="consultant-header">
          <Link to="/consultants">
            <BackIcon className="back-icon" />
          </Link>
          <span className="consultant-title">{ConsultantConstant.CONSULTANT_DETAILS}</span>
        </div>
      </div>

      <div className="consultant-content">
        <div className="consultant-card">
          <ConsultantDetailsCard data={data?.data} onViewDocumentClick={handleToggleModal} id={id} />
        </div>
        <div className="consultant-table">
          <ViewConsultantTable id={id} data={data?.data?.current_plan} />
        </div>
      </div>

      <Modal
        open={documentModalOpen}
        onCancel={handleToggleModal}
        footer={null}
        centered
        title="Consultant Documents"
      >
        {data?.data?.rera_certificate_url && (
          <p>
            <a
              href={data.data.rera_certificate_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1890ff', textDecoration: 'underline' }}
            >
              {ConsultantConstant.VIEW_AND_DOWNLOAD_RERA}
            </a>
          </p>
        )}
        {data?.data?.pan_image_url && (
          <p>
            <a
              href={data.data.pan_image_url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#1890ff', textDecoration: 'underline' }}
            >
              {ConsultantConstant.VIEW_AND_DOWNLOAD_PAN}
            </a>
          </p>
        )}
      </Modal>

    </div>
  )
}

export default ViewConsultant
